import React, { useEffect } from 'react';
import { ReactNotifications } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import styled from 'styled-components';
import {
  Route,
  createRoutesFromElements,
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom'
import './assets/css/css.css';
import './assets/css/responisve.css';
import './assets/css/menu.css';
import './assets/css/flexslider.css';
import './assets/css/bannerslider.css';

import Dashboard from './pages/Dashboard';
import CreateWorkflow from './pages/CreateWorkflow';
import ManageWorkflow from './pages/ManageWorkflow';
import MyProfile from './pages/MyProfile';
import IndentationPage from './components/indentation/IndentationPage';
import WorkflowDetails from './pages/WorkflowDetails';

import Footer from './components/common/Footer';
import Navbar from './components/common/Navbar';
import Page from './components/common/Page';
import DetailsChart from '../src/components/workflow/DetailsChart';
import SKU from './pages/SKU';
import UploadFile from './components/comparison/UploadFile';
import { getCookie } from './services/DataRequestService';
import AdminNavbar from './components/common/AdminNavbar';
import AdminPage from './components/common/AdminPage';
import ComparisonTable from './components/comparison/ComparisonTable';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'


const router = createBrowserRouter(
  createRoutesFromElements(
    <>

      <Route element={<AppLayout />}  >

        <Route path="/"
          element={<Dashboard />}>
        </Route>

        <Route path="/dashboard"
          element={<Dashboard />}>
        </Route>

        <Route path="/createworkflow"
          element={<CreateWorkflow />}>
        </Route>

        <Route path="/manageworkflow"
          element={<ManageWorkflow key="manageworkflow" />}>
        </Route>

        <Route path="/comparison"
          element={<ManageWorkflow key="comparison" />}>
        </Route>

        <Route path="/indentation"
          element={<ManageWorkflow key="indentation" />}>
        </Route>

        <Route path="/indent"
          element={<IndentationPage />}>
        </Route>

        {/* <Route path="/comparison-ManageWorkflow"
          element={<ManageWorkflowForComparison key="manageworkflow_old" />}>
        </Route> */}


        <Route path="/myprofile"
          element={<MyProfile />}>
        </Route>


        <Route path="/workflow"
          element={<WorkflowDetails />}>
        </Route>



        <Route path="/wf/detail-chart"
          element={<DetailsChart />}>
        </Route>
        <Route path="/wf/upload"
          element={<UploadFile />}>
        </Route>

        <Route path="/wf/comparison"
          element={<ComparisonTable />}>
        </Route>

        <Route path="/sku"
          element={<SKU />}>
        </Route>

      </Route>
    </>
  )
);

function AppLayout() {
  return (
    <>
      <ReactNotifications className='custom-react-notification' />
      <Wrapper className="root">
        {
          getCookie('username') === "new user" ?
            <>
              <Navbar />
              <Page />
              <Footer />
            </>
            :
            <>
              <AdminNavbar />
              <AdminPage />
              <Footer />
            </>
        }
      </Wrapper>

    </>

  );
}

function App() {

  useEffect(() => {

    // Array of script sources
    const scripts = [
      'js/jquery.min.js',
      'js/js.js',

      'js/jquery.flexslider.js'
    ];

    // Function to load a script
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve(src);
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.body.appendChild(script);
      });
    };

    // Load all scripts in order
    const loadScriptsSequentially = async () => {
      try {
        for (const script of scripts) {
          await loadScript(script);
        }
        // console.log('All scripts loaded successfully.');
      } catch (error) {
        console.error(error);
      }
    };

    loadScriptsSequentially();

    // Cleanup function to remove scripts on component unmount
    return () => {
      scripts.forEach((src) => {
        const script = document.querySelector(`script[src="${src}"]`);
        if (script) {
          document.body.removeChild(script);
        }
      });
    };
  }, []);

  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>

  )
}

export default App;

const Wrapper = styled.div`  


`